export const defaultStructure = {
  type: 'doc',
  attrs: {
    id: null,
    lp_name: '',
    deletable: true,
    appliedThemeId: null,
    pageId: null,
    backgroundColor: 'transparent',
    data: {},
  },
  content: [
    {
      type: 'container',
      attrs: {
        id: '17333352-8500-4167-8685-0daba6ac0b35',
        lp_name: 'Post Card',
        deletable: true,
        tokens: {},
        mergeTag: null,
        textAlign: 'center',
        width: '100%',
        stackOnMobile: true,
        borderRadius: '8px',
        appliedThemeId: null,
        position: 'relative',
        top: '0px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        positionTopActive: true,
        positionLeftActive: false,
        positionRightActive: true,
        positionBottomActive: false,
        centerHorizontally: false,
        centerVertically: false,
        flexDirection: 'column',
        mobileFlexDirection: 'column',
        backgroundColor: '#ffffff',
        overflow: 'hidden',
        shadow: 'none',
        blur: '0px',
        backgroundDarken: false,
        horizontalAlign: 'left',
        verticalAlign: 'align_start',
        width_max: '100%',
        padding: '0px 0px 0px 0px',
        margin: '0px 0px 0px 0px',
        gap: null,
        borderWidth: '1px',
        borderColor: '#E5E7EB',
        borderStyle: 'none',
        flexWrap: 'nowrap',
        zIndex: 'auto',
      },
      content: [
        {
          type: 'container',
          attrs: {
            id: 'cf8064d9-0e1e-4877-a900-4d74c28727a0',
            lp_name: 'Header',
            deletable: true,
            tokens: {
              backgroundColor: 'disabled',
            },
            mergeTag: null,
            textAlign: 'center',
            width: '100%',
            stackOnMobile: true,
            borderRadius: '8px',
            appliedThemeId: null,
            position: 'relative',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            positionTopActive: true,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            centerHorizontally: false,
            centerVertically: false,
            flexDirection: 'column',
            mobileFlexDirection: 'column',
            backgroundColor: 'transparent',
            overflow: 'visible',
            shadow: 'none',
            blur: '0px',
            backgroundDarken: false,
            horizontalAlign: 'left',
            verticalAlign: 'align_center',
            width_max: '100%',
            padding: '0px 0px 0px 0px',
            margin: '0px 0px 0px 0px',
            gap: null,
            borderWidth: '1px',
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            flexWrap: 'nowrap',
            zIndex: 'auto',
          },
          content: [
            {
              type: 'container',
              attrs: {
                id: '973bdfe5-d32f-45ca-acb6-e4be0f8d835e',
                lp_name: '',
                deletable: true,
                tokens: {},
                mergeTag: null,
                textAlign: 'center',
                width: '100%',
                stackOnMobile: false,
                borderRadius: '8px',
                appliedThemeId: null,
                position: 'absolute',
                top: '0px',
                left: '0px',
                right: '19px',
                bottom: '0px',
                positionTopActive: true,
                positionLeftActive: true,
                positionRightActive: false,
                positionBottomActive: false,
                centerHorizontally: false,
                centerVertically: false,
                flexDirection: 'row',
                mobileFlexDirection: 'row',
                backgroundColor: 'transparent',
                overflow: 'visible',
                shadow: 'none',
                blur: '0px',
                backgroundDarken: false,
                horizontalAlign: 'align_left',
                verticalAlign: 'align_start',
                width_max: '100%',
                padding: '8px 8px 8px 8px',
                margin: '0px 0px 0px 0px',
                gap: '6px',
                borderWidth: '1px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                flexWrap: 'wrap',
                zIndex: 'auto',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '9c34d289-bfd9-4f5a-85c6-93656bfefc94',
                    lp_name: 'Tags',
                    deletable: true,
                    textAlign: 'left',
                    tokens: {
                      backgroundColor: 'background_color',
                    },
                    mergeTag: 'post.tags',
                    width: 'fit-content',
                    maxWidth: '100%',
                    appliedThemeId: null,
                    backgroundColor: '#FFFFFF99',
                    borderRadius: '24px',
                    borderWidth: '0px',
                    borderColor: 'transparent',
                    borderStyle: 'none',
                    lineClampClass: '',
                    padding: '6px 12px 6px 12px',
                    mobilePadding: '6px 12px 6px 12px',
                    lineHeight: '120%',
                    mobileLineHeight: '120%',
                    margin: null,
                    postAuthors: [],
                    postAuthorsTruncateListEnabled: false,
                    postAuthorsImagesEnabled: true,
                    postAuthorsImagesFill: 'inherit',
                    postAuthorsByLine: '',
                    postTimestampDisplay: 'short_date',
                    postReadTimeSuffix: 'min read',
                    postTagsTruncateListEnabled: true,
                    postTagsGap: '4px',
                    postPaidContentGap: '4px',
                    postPaidContentIconSize: 16,
                    postPaidIconFill: '#030712',
                    postPaidText: '',
                    postAuthorsGap: '4px',
                    postAuthorsImageSize: '24px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            mobileFontSize: '12px',
                            fontSize: '12px',
                            fontWeight: '400',
                            fontGradient: null,
                            fontFamily: 'Inter',
                            color: '#030712',
                            tokens: {
                              color: 'text_on_background_color',
                            },
                            appliedThemeId: null,
                            hoverTextColor: null,
                            hoverDecorationLine: null,
                            hoverDecorationColor: null,
                          },
                        },
                      ],
                      text: 'Adventure',
                    },
                  ],
                },
              ],
            },
            {
              type: 'image',
              attrs: {
                id: 'eaf58144-4b75-435e-9f55-f2f55881f25d',
                lp_name: '',
                tokens: {},
                mergeTag: 'post.image',
                width: 300,
                boxShadow: 'none',
                appliedThemeId: null,
                position: 'relative',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                positionTopActive: true,
                positionLeftActive: false,
                positionRightActive: true,
                positionBottomActive: false,
                centerHorizontally: false,
                centerVertically: false,
                url: '',
                open_in_new_tab: false,
                internal_link: false,
                padding: '0px',
                target: null,
                captionUrl: '',
                captionTarget: null,
                src: 'https://media.beehiiv.com/cdn-cgi/image/format=auto/static_assets/site_builder/template/feature_post_6.png',
                title: '',
                alt: 'Adventuring through the Canadian Rockies',
                height: 200,
                align: 'center',
                captionAlign: 'center',
                borderWidth: '0px',
                objectFit: 'cover',
                aspectRatio: 1.5,
                borderRadius: '12px 12px 12px 12px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                isFullWidth: true,
              },
            },
          ],
        },
        {
          type: 'container',
          attrs: {
            id: '9a29752c-0b69-4ac1-8155-3f280ce34e8b',
            lp_name: 'Content',
            deletable: true,
            tokens: {
              backgroundColor: 'disabled',
            },
            mergeTag: null,
            textAlign: 'center',
            width: '100%',
            stackOnMobile: true,
            borderRadius: '0px 0px 0px 0px',
            appliedThemeId: null,
            position: 'relative',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px',
            positionTopActive: true,
            positionLeftActive: false,
            positionRightActive: true,
            positionBottomActive: false,
            centerHorizontally: false,
            centerVertically: false,
            flexDirection: 'column',
            mobileFlexDirection: 'column',
            backgroundColor: 'transparent',
            overflow: 'visible',
            shadow: 'none',
            blur: '0px',
            backgroundDarken: false,
            horizontalAlign: 'left',
            verticalAlign: 'align_center',
            width_max: '100%',
            mobilePadding: '8px 8px 8px 8px',
            padding: '8px 8px 8px 8px',
            margin: '0px 0px 0px 0px',
            gap: '6px',
            borderWidth: '1px',
            borderColor: '#E5E7EB',
            borderStyle: 'none',
            flexWrap: 'nowrap',
            zIndex: 'auto',
          },
          content: [
            {
              type: 'container',
              attrs: {
                id: '9f26ffd1-9e6c-4fc5-b672-be28587ac17b',
                lp_name: 'Details',
                deletable: true,
                tokens: {
                  backgroundColor: 'disabled',
                },
                mergeTag: null,
                textAlign: 'center',
                width: '100%',
                stackOnMobile: true,
                borderRadius: '8px',
                appliedThemeId: null,
                position: 'relative',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                positionTopActive: true,
                positionLeftActive: false,
                positionRightActive: true,
                positionBottomActive: false,
                centerHorizontally: false,
                centerVertically: false,
                flexDirection: 'row',
                mobileFlexDirection: 'row',
                backgroundColor: 'transparent',
                overflow: 'visible',
                shadow: 'none',
                blur: '0px',
                backgroundDarken: false,
                horizontalAlign: 'center',
                verticalAlign: 'align_start',
                width_max: '100%',
                mobilePadding: '0px 0px 0px 0px',
                padding: '0px 0px 0px 0px',
                margin: '0px 0px 0px 0px',
                gap: '8px',
                borderWidth: '1px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                mobileBorderStyle: 'none',
                flexWrap: 'nowrap',
                zIndex: 'auto',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: '84396f7c-07dc-4e6b-a68e-3a50ec144cd4',
                    lp_name: 'Paid Tag',
                    deletable: true,
                    textAlign: 'left',
                    tokens: {
                      postPaidIconFill: 'primary_color',
                    },
                    mergeTag: 'post.paidContent',
                    width: 'fit-content',
                    maxWidth: '100%',
                    appliedThemeId: null,
                    backgroundColor: 'transparent',
                    borderRadius: '0px',
                    borderWidth: '0px',
                    borderColor: 'inherit',
                    borderStyle: 'none',
                    lineClampClass: '',
                    padding: '0px 0px 0px 0px',
                    mobilePadding: '0px 0px 0px 0px',
                    lineHeight: '120%',
                    mobileLineHeight: '120%',
                    margin: null,
                    postAuthors: [],
                    postAuthorsTruncateListEnabled: false,
                    postAuthorsImagesEnabled: true,
                    postAuthorsImagesFill: 'inherit',
                    postAuthorsByLine: '',
                    postTimestampDisplay: 'short_date',
                    postReadTimeSuffix: 'min read',
                    postTagsTruncateListEnabled: true,
                    postTagsGap: '4px',
                    postPaidContentGap: '4px',
                    postPaidContentIconSize: 16,
                    postPaidIconFill: '#030712',
                    postPaidText: '',
                    postAuthorsGap: '4px',
                    postAuthorsImageSize: '24px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            mobileFontSize: '12px',
                            fontSize: '12px',
                            fontWeight: '400',
                            fontGradient: null,
                            fontFamily: 'Inter',
                            color: null,
                            tokens: {
                              color: 'disabled',
                            },
                            appliedThemeId: null,
                            hoverTextColor: null,
                            hoverDecorationLine: null,
                            hoverDecorationColor: null,
                          },
                        },
                      ],
                      text: 'Paid',
                    },
                  ],
                },
                {
                  type: 'container',
                  attrs: {
                    id: '48ed74c2-d93a-4e1b-bae1-1cebe41ef318',
                    lp_name: '',
                    deletable: true,
                    tokens: {
                      backgroundColor: 'disabled',
                    },
                    mergeTag: null,
                    textAlign: 'center',
                    width: 'auto',
                    stackOnMobile: true,
                    borderRadius: '8px',
                    appliedThemeId: null,
                    position: 'relative',
                    top: '0px',
                    left: '0px',
                    right: '0px',
                    bottom: '0px',
                    positionTopActive: true,
                    positionLeftActive: false,
                    positionRightActive: true,
                    positionBottomActive: false,
                    centerHorizontally: false,
                    centerVertically: false,
                    flexDirection: 'row',
                    mobileFlexDirection: 'row',
                    backgroundColor: 'transparent',
                    overflow: 'visible',
                    shadow: 'none',
                    blur: '0px',
                    backgroundDarken: false,
                    horizontalAlign: 'center',
                    verticalAlign: 'align_center',
                    width_max: null,
                    mobilePadding: '0px 0px 0px 0px',
                    padding: '0px 0px 0px 0px',
                    margin: '0px 0px 0px 0px',
                    gap: null,
                    borderWidth: '1px',
                    borderColor: '#E5E7EB',
                    borderStyle: 'none',
                    flexWrap: 'nowrap',
                    zIndex: 'auto',
                  },
                  content: [
                    {
                      type: 'paragraph',
                      attrs: {
                        id: '8a1d156a-1185-4f1e-8ffb-7ab6efde1cfb',
                        lp_name: 'Date',
                        deletable: true,
                        textAlign: 'left',
                        tokens: {},
                        mergeTag: 'post.timestamp',
                        width: 'fit-content',
                        maxWidth: '100%',
                        appliedThemeId: null,
                        backgroundColor: 'transparent',
                        borderRadius: '0px',
                        borderWidth: '0px',
                        borderColor: 'transparent',
                        borderStyle: 'none',
                        lineClampClass: '',
                        padding: '0px 0px 0px 0px',
                        mobilePadding: '0px 0px 0px 0px',
                        lineHeight: '120%',
                        mobileLineHeight: '120%',
                        margin: null,
                        postAuthors: [],
                        postAuthorsTruncateListEnabled: false,
                        postAuthorsImagesEnabled: true,
                        postAuthorsImagesFill: 'inherit',
                        postAuthorsByLine: '',
                        postTimestampDisplay: 'short_date',
                        postReadTimeSuffix: 'min read',
                        postTagsTruncateListEnabled: true,
                        postTagsGap: '4px',
                        postPaidContentGap: '4px',
                        postPaidContentIconSize: 16,
                        postPaidIconFill: '#030712',
                        postPaidText: '',
                        postAuthorsGap: '4px',
                        postAuthorsImageSize: '24px',
                      },
                      content: [
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                mobileFontSize: '12px',
                                fontSize: '12px',
                                fontWeight: '400',
                                fontGradient: null,
                                fontFamily: 'Inter',
                                color: '#030712',
                                tokens: {},
                                appliedThemeId: null,
                                hoverTextColor: null,
                                hoverDecorationLine: null,
                                hoverDecorationColor: null,
                              },
                            },
                          ],
                          text: 'Jan 31, 2025',
                        },
                      ],
                    },
                    {
                      type: 'paragraph',
                      attrs: {
                        id: '7a8fb0b5-ce31-4f66-af3a-5648688eb27e',
                        lp_name: 'Dot Separator',
                        deletable: true,
                        textAlign: 'center',
                        tokens: {},
                        mergeTag: null,
                        width: 'fit-content',
                        maxWidth: '100%',
                        appliedThemeId: null,
                        backgroundColor: 'transparent',
                        borderRadius: '0px',
                        borderWidth: '0px',
                        borderColor: 'transparent',
                        borderStyle: 'none',
                        lineClampClass: '',
                        padding: '4px 4px 4px 4px',
                        mobilePadding: '4px 4px 4px 4px',
                        lineHeight: '120%',
                        mobileLineHeight: '120%',
                        margin: null,
                        postAuthors: [],
                        postAuthorsTruncateListEnabled: false,
                        postAuthorsImagesEnabled: true,
                        postAuthorsImagesFill: 'inherit',
                        postAuthorsByLine: '',
                        postTimestampDisplay: 'short_date',
                        postReadTimeSuffix: 'min read',
                        postTagsTruncateListEnabled: true,
                        postTagsGap: '4px',
                        postPaidContentGap: '4px',
                        postPaidContentIconSize: 16,
                        postPaidIconFill: '#030712',
                        postPaidText: '',
                        postAuthorsGap: '4px',
                        postAuthorsImageSize: '24px',
                      },
                      content: [
                        {
                          type: 'text',
                          marks: [
                            {
                              type: 'textStyle',
                              attrs: {
                                mobileFontSize: '12px',
                                fontSize: '12px',
                                fontWeight: '400',
                                fontGradient: null,
                                fontFamily: 'Inter',
                                color: '#030712',
                                tokens: {},
                                appliedThemeId: null,
                                hoverTextColor: null,
                                hoverDecorationLine: null,
                                hoverDecorationColor: null,
                              },
                            },
                          ],
                          text: '•',
                        },
                      ],
                    },
                    {
                      type: 'container',
                      attrs: {
                        id: '24f0daea-dde4-4517-9412-6673567d68bd',
                        lp_name: '',
                        deletable: true,
                        tokens: {},
                        mergeTag: null,
                        textAlign: 'center',
                        width: 'auto',
                        stackOnMobile: false,
                        borderRadius: '8px',
                        appliedThemeId: null,
                        position: 'relative',
                        top: '0px',
                        left: '0px',
                        right: '0px',
                        bottom: '0px',
                        positionTopActive: true,
                        positionLeftActive: false,
                        positionRightActive: true,
                        positionBottomActive: false,
                        centerHorizontally: false,
                        centerVertically: false,
                        flexDirection: 'row',
                        mobileFlexDirection: 'row',
                        backgroundColor: 'transparent',
                        overflow: 'visible',
                        shadow: 'none',
                        blur: '0px',
                        backgroundDarken: false,
                        horizontalAlign: 'align_center',
                        verticalAlign: 'align_center',
                        width_max: '100%',
                        padding: '0px 0px 0px 0px',
                        margin: '0px 0px 0px 0px',
                        gap: null,
                        borderWidth: '1px',
                        borderColor: '#E5E7EB',
                        borderStyle: 'none',
                        flexWrap: 'nowrap',
                        zIndex: 'auto',
                      },
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            id: 'b873bcd7-a028-4fae-b7a6-bc2fc0dd2cb4',
                            lp_name: 'Read Time',
                            deletable: true,
                            textAlign: 'left',
                            tokens: {},
                            mergeTag: 'post.readTime',
                            width: 'fit-content',
                            maxWidth: '100%',
                            appliedThemeId: null,
                            backgroundColor: 'transparent',
                            borderRadius: '0px',
                            borderWidth: '0px',
                            borderColor: 'transparent',
                            borderStyle: 'none',
                            lineClampClass: '',
                            padding: '0px 0px 0px 0px',
                            mobilePadding: '0px 0px 0px 0px',
                            lineHeight: '120%',
                            mobileLineHeight: '120%',
                            margin: null,
                            postAuthors: [],
                            postAuthorsTruncateListEnabled: false,
                            postAuthorsImagesEnabled: true,
                            postAuthorsImagesFill: 'inherit',
                            postAuthorsByLine: '',
                            postTimestampDisplay: 'short_date',
                            postReadTimeSuffix: 'min read',
                            postTagsTruncateListEnabled: true,
                            postTagsGap: '4px',
                            postPaidContentGap: '4px',
                            postPaidContentIconSize: 16,
                            postPaidIconFill: '#030712',
                            postPaidText: '',
                            postAuthorsGap: '4px',
                            postAuthorsImageSize: '24px',
                          },
                          content: [
                            {
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    mobileFontSize: '12px',
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    fontGradient: null,
                                    fontFamily: 'Inter',
                                    color: '#030712',
                                    tokens: {},
                                    appliedThemeId: null,
                                    hoverTextColor: null,
                                    hoverDecorationLine: null,
                                    hoverDecorationColor: null,
                                  },
                                },
                              ],
                              text: '3 min read',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: 'container',
              attrs: {
                id: 'c57f4da0-6945-429f-ad02-6bb6e2d9e9de',
                lp_name: 'Titles',
                deletable: true,
                tokens: {
                  backgroundColor: 'disabled',
                },
                mergeTag: null,
                textAlign: 'center',
                width: '100%',
                stackOnMobile: true,
                borderRadius: '8px',
                appliedThemeId: null,
                position: 'relative',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                positionTopActive: true,
                positionLeftActive: false,
                positionRightActive: true,
                positionBottomActive: false,
                centerHorizontally: false,
                centerVertically: false,
                flexDirection: 'column',
                mobileFlexDirection: 'column',
                backgroundColor: 'transparent',
                overflow: 'visible',
                shadow: 'none',
                blur: '0px',
                backgroundDarken: false,
                horizontalAlign: 'left',
                verticalAlign: 'align_center',
                width_max: '100%',
                padding: '0px 0px 0px 0px',
                margin: '0px 0px 0px 0px',
                gap: '6px',
                borderWidth: '1px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                flexWrap: 'nowrap',
                zIndex: 'auto',
              },
              content: [
                {
                  type: 'heading',
                  attrs: {
                    id: 'e5135411-ae9d-4684-b1f9-75c93f62d2a5',
                    lp_name: 'Title',
                    deletable: true,
                    textAlign: 'left',
                    tokens: {},
                    mergeTag: 'post.title',
                    width: '100%',
                    maxWidth: '100%',
                    appliedThemeId: null,
                    level: 3,
                    lineClampClass: 'line-clamp-2',
                    backgroundColor: 'transparent',
                    borderRadius: '0px',
                    borderWidth: '0px',
                    borderColor: 'transparent',
                    borderStyle: 'none',
                    lineHeight: '120%',
                    mobileLineHeight: '120%',
                    padding: '0px 0px 0px 0px',
                    mobilePadding: '0px 0px 0px 0px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            mobileFontSize: '24px',
                            fontSize: '24px',
                            fontWeight: '700',
                            fontGradient: null,
                            fontFamily: 'Inter',
                            color: '#030712',
                            tokens: {
                              color: 'text_on_background_color',
                            },
                            appliedThemeId: null,
                            hoverTextColor: null,
                            hoverDecorationLine: null,
                            hoverDecorationColor: null,
                          },
                        },
                      ],
                      text: 'Adventuring through the Canadian Rockies',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'cab24577-23ce-4e8f-a8f1-58f3538c516a',
                    lp_name: 'Subtitle',
                    deletable: true,
                    textAlign: 'left',
                    tokens: {},
                    mergeTag: 'post.subtitle',
                    width: '100%',
                    maxWidth: '100%',
                    appliedThemeId: null,
                    backgroundColor: 'transparent',
                    borderRadius: '0px',
                    borderWidth: '0px',
                    borderColor: 'transparent',
                    borderStyle: 'none',
                    lineClampClass: 'line-clamp-3',
                    padding: '0px 0px 0px 0px',
                    mobilePadding: '0px 0px 0px 0px',
                    lineHeight: '120%',
                    mobileLineHeight: '120%',
                    margin: null,
                    postAuthors: [],
                    postAuthorsTruncateListEnabled: false,
                    postAuthorsImagesEnabled: true,
                    postAuthorsImagesFill: 'inherit',
                    postAuthorsByLine: '',
                    postTimestampDisplay: 'short_date',
                    postReadTimeSuffix: 'min read',
                    postTagsTruncateListEnabled: true,
                    postTagsGap: '4px',
                    postPaidContentGap: '4px',
                    postPaidContentIconSize: 16,
                    postPaidIconFill: '#030712',
                    postPaidText: '',
                    postAuthorsGap: '4px',
                    postAuthorsImageSize: '24px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            mobileFontSize: '16px',
                            fontSize: '16px',
                            fontWeight: '400',
                            fontGradient: null,
                            fontFamily: 'Inter',
                            color: '#030712',
                            tokens: {},
                            appliedThemeId: null,
                            hoverTextColor: null,
                            hoverDecorationLine: null,
                            hoverDecorationColor: null,
                          },
                        },
                      ],
                      text: "With their ice-capped peaks scraping the sky, the Canadian Rockies contain some of North America's most spectacular mountain scenery and abundant wildlife.",
                    },
                  ],
                },
              ],
            },
            {
              type: 'container',
              attrs: {
                id: '5d4fdf5a-d9c1-4ea1-abd4-b1ac1f5e2aa4',
                lp_name: 'Authors',
                deletable: true,
                tokens: {
                  backgroundColor: 'disabled',
                },
                mergeTag: null,
                textAlign: 'center',
                width: '100%',
                stackOnMobile: true,
                borderRadius: '8px',
                appliedThemeId: null,
                position: 'relative',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px',
                positionTopActive: true,
                positionLeftActive: false,
                positionRightActive: true,
                positionBottomActive: false,
                centerHorizontally: false,
                centerVertically: false,
                flexDirection: 'column',
                mobileFlexDirection: 'column',
                backgroundColor: 'transparent',
                overflow: 'visible',
                shadow: 'none',
                blur: '0px',
                backgroundDarken: false,
                horizontalAlign: 'left',
                verticalAlign: 'align_center',
                width_max: '100%',
                mobilePadding: '9px 0px 0px 0px',
                padding: '8px 0px 0px 0px',
                margin: '0px 0px 0px 0px',
                gap: '12px',
                borderWidth: '1px',
                borderColor: '#E5E7EB',
                borderStyle: 'none',
                flexWrap: 'nowrap',
                zIndex: 'auto',
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    id: 'ccbd8fc5-a848-48e2-85ea-aa2aaa4b9d36',
                    lp_name: 'Names',
                    deletable: true,
                    textAlign: 'left',
                    tokens: {},
                    mergeTag: 'post.authors',
                    width: 'fit-content',
                    maxWidth: '100%',
                    appliedThemeId: null,
                    backgroundColor: 'transparent',
                    borderRadius: '0px',
                    borderWidth: '0px',
                    borderColor: 'transparent',
                    borderStyle: 'none',
                    lineClampClass: '',
                    padding: '0px 0px 0px 0px',
                    mobilePadding: '0px 0px 0px 0px',
                    lineHeight: '80%',
                    mobileLineHeight: '80%',
                    margin: null,
                    postAuthors: [],
                    postAuthorsTruncateListEnabled: true,
                    postAuthorsImagesEnabled: true,
                    postAuthorsTextEnabled: true,
                    postAuthorsImagesFill: 'inherit',
                    postAuthorsByLine: '',
                    postTimestampDisplay: 'short_date',
                    postReadTimeSuffix: 'min read',
                    postTagsTruncateListEnabled: true,
                    postTagsGap: '4px',
                    postPaidContentGap: '4px',
                    postPaidContentIconSize: 16,
                    postPaidIconFill: '#030712',
                    postPaidText: '',
                    postAuthorsGap: '4px',
                    postAuthorsImageSize: '24px',
                  },
                  content: [
                    {
                      type: 'text',
                      marks: [
                        {
                          type: 'textStyle',
                          attrs: {
                            mobileFontSize: '14px',
                            fontSize: '14px',
                            fontWeight: '400',
                            fontGradient: null,
                            fontFamily: 'Inter',
                            color: '#030712',
                            tokens: {},
                            appliedThemeId: null,
                            hoverTextColor: null,
                            hoverDecorationLine: null,
                            hoverDecorationColor: null,
                          },
                        },
                      ],
                      text: 'Oliver Buchannon, +1',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
